export class StockUpdateByDomestic{
    locationId:number;
    stockId:number;
    varientId:number;
    packStyleId:number;
    totalCartons:number;
    loosePouches:number;
    stockQuantity:number;
    stockLoosePouches:number;
    constructer(locationId:number,stockId:number,varientId:number, packStyleId:number,totalCartons:number, loosePouches:number,stockQuantity:number,stockLoosePouches:number)
    {
        this.locationId=locationId;
        this.packStyleId=packStyleId;
        this.stockId=stockId;
        this.varientId=varientId;   
        this.totalCartons=totalCartons;
        this.loosePouches=loosePouches;
        this.stockQuantity=stockQuantity;
        this.stockLoosePouches=stockLoosePouches;
    }
}